var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppIcon = function SvgAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "app-icon_svg__a",
    d: "m11.584.734 5.85 3.492a2.4 2.4 0 0 1 1.17 2.06v7.124a2.4 2.4 0 0 1-1.17 2.061l-5.85 3.492a2.4 2.4 0 0 1-2.46 0l-5.85-3.492a2.4 2.4 0 0 1-1.17-2.06V6.286a2.4 2.4 0 0 1 1.17-2.061L9.124.734a2.4 2.4 0 0 1 2.46 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "app-icon_svg__d",
    d: "M9.71 8.12H7.861V6.97h4.983v1.15h-1.847v5.213H9.709V8.12zm0 0v1.188l1.288-1.189H9.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-icon_svg__b",
    x1: "97.627%",
    x2: "1.57%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#465FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6E4EF6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "app-icon_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#app-icon_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#app-icon_svg__b)",
    xlinkHref: "#app-icon_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A7A7A7",
    mask: "url(#app-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2-.697h17v21H2z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "app-icon_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#app-icon_svg__d"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#app-icon_svg__d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#app-icon_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.424h16v15H2z"
  })))));
};
export default SvgAppIcon;